export class ConveyanceConfigResponse {
  ConveyanceConfigID: number;
  ConveyanceID: number;
  ConfigName: string;
  ConfigValue: string;
}
